import { render, staticRenderFns } from "./SimpleEventCreator.vue?vue&type=template&id=015d06c1&scoped=true&"
import script from "./SimpleEventCreator.vue?vue&type=script&lang=js&"
export * from "./SimpleEventCreator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015d06c1",
  null
  
)

export default component.exports